

















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CustomStore from 'devextreme/data/custom_store';
import {
  DxColumn,
  DxDataGrid,
  DxEditing,
  DxPaging,
  DxScrolling
} from 'devextreme-vue/data-grid';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { PhaseTypeDto } from '@/models/PhaseTypeDto';
import { PhaseTypeService } from '@/service/PhaseTypeService';
import _ from 'lodash';

@Component({
  components: {
    DxColumn,
    DxDataGrid,
    DxEditing,
    DxPaging,
    DxPopup,
    DxScrolling,
    DxToolbarItem
  }
})
export default class PhaseVerbEditor extends Vue {
  private readonly phaseTypeService: PhaseTypeService = new PhaseTypeService();
  readonly dataGridRefKey: string = 'data-grid';

  @Prop({ required: true })
  visible!: boolean;

  created() {
    document.addEventListener('keyup', this.onKeyup, true);
    document.addEventListener('keydown', this.onKeydown, true);
  }

  destroyed() {
    document.removeEventListener('keyup', this.onKeyup, true);
    document.removeEventListener('keydown', this.onKeydown, true);
  }

  get dataGrid() {
    let dataGridRef = this.$refs[this.dataGridRefKey];
    if (dataGridRef != null) {
      return (dataGridRef as DxDataGrid).instance;
    }
  }

  get dataSource() {
    return new CustomStore({
      key: 'PhaseTypeId',
      loadMode: 'raw',
      load: () => this.phaseTypeService.getAll(),
      update: (key, values) => this.phaseTypeService.update(key, values)
    });
  }

  get saveButtonOptions() {
    return {
      text: 'Save',
      type: 'default',
      stylingMode: 'contained',
      onClick: this.saveAndClose
    };
  }

  get cancelButtonOptions() {
    return {
      text: 'Cancel',
      type: 'normal',
      stylingMode: 'contained',
      onClick: this.cancelAndClose
    };
  }

  private hasEditData() {
    return this.dataGrid != null && this.dataGrid.hasEditData();
  }

  private saveEditData() {
    if (this.dataGrid != null) {
      this.dataGrid.saveEditData();
    }
  }

  private cancelEditData() {
    if (this.dataGrid != null) {
      this.dataGrid.cancelEditData();
    }
  }

  onToolbarPreparing(e: any) {
    e.toolbarOptions.visible = false;
  }

  onEditorPreparing(e: any) {
    if (e.parentType === 'dataRow' && e.dataField === 'PhaseVerb') {
      e.editorOptions.maxLength = 50;
    }
  }

  onRowUpdating(e: any) {
    e.newData = _.merge({}, e.oldData, e.newData);
  }

  saveAndClose() {
    this.save();
    this.close();
  }

  private save() {
    if (this.hasEditData()) {
      this.saveEditData();
    }
  }

  cancelAndClose() {
    this.cancel();
    this.close();
  }

  private cancel() {
    if (this.hasEditData()) {
      this.cancelEditData();
    }
  }

  onHiding() {
    this.close();
  }

  onHidden() {
    this.reset();
  }

  private reset() {
    this.cancel();
  }

  private close() {
    this.$emit('hiding');
  }

  private onKeydown(e: KeyboardEvent) {
    if (this.isSaveShortcut(e)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  private onKeyup(e: KeyboardEvent) {
    if (this.isSaveShortcut(e)) {
      e.preventDefault();
      e.stopPropagation();
      this.focusDataGrid();
      this.saveAndClose();
    }
  }

  private isSaveShortcut(e: KeyboardEvent) {
    return e.key === 'Enter' && (e.ctrlKey || e.shiftKey);
  }

  private focusDataGrid() {
    if (this.dataGrid != null) {
      this.dataGrid.focus();
    }
  }
}
